import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requireUserType }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireUserType && user.userType !== requireUserType) {
    const redirectPath = user.userType === 'PERSONAL' ? '/personal/dashboard' : '/enterprise/orgs';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
